export default function SiteFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      style={{ backgroundColor: '#0d0d0d', borderTop: '1px solid rgba(255,255,255,0.06)' }}
      aria-label="フッター"
    >
      {/* Main footer content */}
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">

          {/* Logo & Description */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src="/logo-icon.png" alt="baba Kaba アイコンロゴ" className="h-7 w-7 object-contain" />
              <span
                className="text-xl font-black tracking-wider"
                style={{ color: '#f5a623', fontFamily: '"Oswald", sans-serif' }}
              >
                baba Kaba
              </span>
            </div>
            <p
              className="text-sm leading-relaxed"
              style={{ color: 'rgba(255,255,255,0.5)', fontFamily: '"Noto Sans JP", sans-serif', lineHeight: '1.9' }}
            >
              東京都青梅市の中古タイヤ専門店。<br />
              軽自動車からトラックまで、<br />
              良質な中古タイヤを適正価格でご提供。
            </p>
          </div>

          {/* Business hours */}
          <div>
            <h3
              className="text-sm font-bold text-white mb-5 flex items-center gap-2"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-time-line" style={{ color: '#f5a623' }}></i>
              </div>
              営業時間
            </h3>
            <dl className="space-y-3">
              {[
                { dt: '平日', dd: '9:00〜18:00' },
                { dt: '土日祝', dd: '9:00〜18:00' },
                { dt: '定休日', dd: '不定期（基本年中無休）' },
              ].map((item) => (
                <div key={item.dt} className="flex items-baseline gap-3">
                  <dt
                    className="text-xs w-16 flex-shrink-0"
                    style={{ color: 'rgba(255,255,255,0.4)', fontFamily: '"Noto Sans JP", sans-serif' }}
                  >
                    {item.dt}
                  </dt>
                  <dd
                    className="text-sm font-medium"
                    style={{ color: 'rgba(255,255,255,0.8)', fontFamily: '"Noto Sans JP", sans-serif' }}
                  >
                    {item.dd}
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          {/* Address & Phone */}
          <div>
            <h3
              className="text-sm font-bold text-white mb-5 flex items-center gap-2"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-map-pin-line" style={{ color: '#f5a623' }}></i>
              </div>
              店舗情報
            </h3>
            <div className="space-y-3">
              <p
                className="text-sm leading-loose"
                style={{ color: 'rgba(255,255,255,0.7)', fontFamily: '"Noto Sans JP", sans-serif' }}
              >
                〒198-0001<br />東京都青梅市成木1丁目1番
              </p>
              <a
                href="tel:08097798744"
                className="flex items-center gap-2 text-base font-bold hover:opacity-80 transition-opacity cursor-pointer"
                style={{ color: '#f5a623', fontFamily: '"Noto Sans JP", sans-serif' }}
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-fill text-sm"></i>
                </div>
                080-9779-8744
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright bar */}
      <div
        className="py-5 px-4"
        style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}
      >
        <p
          className="text-center text-xs"
          style={{ color: 'rgba(255,255,255,0.35)', fontFamily: '"Noto Sans JP", sans-serif' }}
        >
          © {currentYear} baba Kaba 無断複写・転載を禁じます。
        </p>
      </div>
    </footer>
  );
}